import i18n from '@/locales/i18n'
import type { RouteType } from '@/types/Route'
import { ref } from 'vue'
import EventsTableView from '../../views/EventsView/EventsTableView.vue'

export const HOME_ROUTE_NAME = 'homePage'

const routes: RouteType[] = [
    {
        path: '/',
        name: HOME_ROUTE_NAME,
        component: EventsTableView,
        meta: {
            title: ref(i18n.global.t('menu.home'))
        }
    }
]

export default routes
